import EnvVars from "~/env-vars"

import type { GraphQLResponseBodyWithError } from "./graphql"

export type GraphqlErrorResponse = {
  request: {
    query: string
    variables: Record<string, unknown>
  }
  response?: GraphQLResponseBodyWithError & {
    headers: Record<string, unknown>
    status: number
  }
  message: string
  stack: string
}

export function isGraphQLResponseError(
  error: unknown,
): error is GraphqlErrorResponse {
  return (
    typeof error === `object` &&
    error !== null &&
    typeof (error as GraphqlErrorResponse).response === `object` &&
    (error as GraphqlErrorResponse).response !== null &&
    Array.isArray((error as GraphqlErrorResponse).response?.errors)
  )
}

export function isUnauthenticatedError(
  error: GraphqlErrorResponse,
): boolean | undefined {
  console.warn(`isUnauthenticatedError`, error)

  return error?.response?.errors?.some(
    (e) =>
      e.extensions?.code === `UNAUTHENTICATED` ||
      e.extensions?.error === `UnauthorizedException` ||
      e.extensions?.status === 401,
  )
}

export function handleErrorTypes(error: GraphqlErrorResponse): void {
  if (isUnauthenticatedError(error)) {
    console.warn(`Unauthenticated error, redirecting to login`)
    localStorage.setItem(`jwt`, ``)
    window.location.replace(`${EnvVars.API_URL}/auth/sso/login`)
  }
}

export const handleGraphqlError = (error: unknown): void => {
  if (isGraphQLResponseError(error)) {
    return handleErrorTypes(error)
  }
  console.error(error)
}
